// assets/reviews-scroll.js
// Stiletto loads as type="module" from snippets/theme-globals.liquid

const STAR_SELECTORS = [
  '.jdgm-prev-badge__stars',         // your provided stars element
  '.jdgm-preview-badge',             // common Judge.me wrapper
  '.jdgm-prev-badge'                 // common Judge.me wrapper
];

function closestAny(el, selectors) {
  if (!el || !el.closest) return null;
  for (const sel of selectors) {
    const hit = el.closest(sel);
    if (hit) return hit;
  }
  return null;
}

function findStarsFromEvent(e) {
  // 1) clicks often land on inner spans (jdgm-star)
  const fromTarget = closestAny(e.target, STAR_SELECTORS);
  if (fromTarget) return fromTarget;

  // 2) keyboard events: use focused element
  const active = document.activeElement;
  const fromActive = closestAny(active, STAR_SELECTORS);
  if (fromActive) return fromActive;

  return null;
}

function findReviewsEl() {
  // Prefer non-link containers first (prevents focus/overlay weirdness)
  return (
    document.querySelector('#judgeme_product_reviews') ||
    document.querySelector('.jdgm-widget.jdgm-review-widget') ||
    document.querySelector('.jdgm-review-widget') ||
    document.querySelector('.jdgm-rev-widg') ||
    document.querySelector('.jdgm-rev') ||
    document.querySelector('.jdgm-rev-snippet') ||
    // LAST resort: link element that definitely exists in your markup
    document.querySelector('.jdgm-rev-snippet-card__full-review-link')
  );
}

function openContainers(el) {
  const details = el.closest && el.closest('details');
  if (details) details.open = true;
}

function blurActive() {
  const active = document.activeElement;
  if (active && typeof active.blur === 'function') active.blur();
}

function scrollToEl(el) {
  const offset = 120; // adjust if your sticky header differs
  const y = el.getBoundingClientRect().top + window.pageYOffset - offset;

  window.scrollTo({ top: y, behavior: 'smooth' });

  // Drop focus so cross-sells are clickable immediately after scrolling
  setTimeout(() => blurActive(), 350);
}

function scrollToReviewsWithWait() {
  const start = Date.now();

  (function poll() {
    const reviewsEl = findReviewsEl();
    if (reviewsEl) {
      openContainers(reviewsEl);
      scrollToEl(reviewsEl);
      return;
    }

    // Wait up to 3s for Judge.me to inject
    if (Date.now() - start < 3000) setTimeout(poll, 100);
  })();
}

// CLICK support
document.addEventListener(
  'click',
  (e) => {
    const stars = findStarsFromEvent(e);
    if (!stars) return;

    e.preventDefault(); // only prevent default when we are sure it’s the stars
    if (typeof stars.blur === 'function') stars.blur();

    scrollToReviewsWithWait();
  },
  true
);

// KEYBOARD support (Enter + Space)
document.addEventListener(
  'keydown',
  (e) => {
    const stars = findStarsFromEvent(e);
    if (!stars) return;

    if (e.key === 'Enter') {
      e.preventDefault();
      if (typeof stars.blur === 'function') stars.blur();
      scrollToReviewsWithWait();
    }

    // prevent page scroll on Space; trigger action on keyup
    if (e.key === ' ') e.preventDefault();
  },
  true
);

document.addEventListener(
  'keyup',
  (e) => {
    const stars = findStarsFromEvent(e);
    if (!stars) return;

    if (e.key !== ' ') return;
    e.preventDefault();

    if (typeof stars.blur === 'function') stars.blur();
    scrollToReviewsWithWait();
  },
  true
);